import React, { useEffect, useState } from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoHeader from './Estacionamientos/EstacionamientoHeader'
import EstacionamientoService from "../services/EstacionamientoService";
import CiudadanosService from "../services/CiudadanosService";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import Botonera from "./Estacionamientos/Botonera";
import BotoneraWithFooter from "./Estacionamientos/BotoneraWithFooter";
import { Spinner } from "reactstrap";
import LogServices from "../services/LogServices";
import EstacionamientoSmallHeader from "./Estacionamientos/EstacionamientoSmallHeader";



const EstacionamientoSites = () => {
    const navigate = useNavigate();

    const [availableCredit, setAvailableCredit] = useState("...");
    const [loading, setLoading] = useState(true);

    
    
    
    const consultarEstado = () => {
        EstacionamientoService.consultarEstado(localStorage.getItem("estacionamiento_celular"), localStorage.getItem("estacionamiento_token"))
        .then((resp)=> {
            if (resp.data.errorCode=="2" || resp.data.errorCode=="77") {
                localStorage.setItem("estado_estacionamiento","1")
                localStorage.setItem("estacionamiento_horaini", resp.data.extra.estacionamientos[0].hora);
                if (resp.data.extra.informacionSensorParking!=null)
                    localStorage.setItem("estacionamiento_lugar", resp.data.extra.informacionSensorParking.externalDeviceId);
                localStorage.setItem("estacionamiento_patente", resp.data.extra.estacionamientos[0].matricula);
            }
            else {
                localStorage.removeItem("estado_estacionamiento");
                localStorage.removeItem("estacionamiento_horaini");
                localStorage.removeItem("estacionamiento_lugar");
                localStorage.removeItem("estacionamiento_patente");

            }
            setLoading(false);

        })
        .catch((resp)=>{
            LogServices.log("Consultar estado estacionamiento ", localStorage.getItem("estacionamiento_celular"), resp.message, resp);
            navigate("/estacionamientoerror");
        })
    }   
    
    const hacerRegistro = () =>{
        EstacionamientoService.registro(localStorage.getItem("estacionamiento_celular"),
        localStorage.getItem("estacionamiento_fecha_nacimiento"),
        localStorage.getItem("estacionamiento_documento"),
        localStorage.getItem("estacionamiento_email")
        ).then((resp)=>{
            console.log(resp);
            navigate("/estacionamientoactivate");
        })
        .catch((error)=>{
            console.log(error);
            LogServices.log("Error Registro nuevo estacionamiento",localStorage.getItem("estacionamiento_celular"), error.message, error);
            navigate("/estacionamientoerror");
        });
    }

    const hacerOlvidoClave = () =>{
        EstacionamientoService.olvideClave(localStorage.getItem("estacionamiento_celular"))
        .then((resp)=>{
            console.log(resp);
            navigate("/estacionamientoactivate");
        })
        .catch((error)=>{
            console.log(error);
            LogServices.log("Error Solicitud nueva clave para celular",localStorage.getItem("estacionamiento_celular"), error.message, error);
            navigate("/estacionamientoerror");
        });
    }
    
    const loginEstacionamientos = () => {
            EstacionamientoService.login(localStorage.getItem("estacionamiento_celular"), localStorage.getItem("estacionamiento_pass"))
            //EstacionamientoService.login("1133844364", localStorage.getItem("estacionamiento_pass"))
            .then((resp)=>{
                console.log(resp.data);

                localStorage.setItem("estacionamiento_codigoerror", resp.data.errorCode);
                localStorage.setItem("desc_error", "ok");
                localStorage.setItem("estacionamiento_token", resp.data.token);
                localStorage.setItem("estacionamiento_celular",resp.data.extra.nroCuenta);
                localStorage.setItem("estacionamiento_email",resp.data.extra.Email);
                consultarEstado();
                setAvailableCredit(resp.data.saldoString); 
                localStorage.setItem("estacionamiento_codigoerror", resp.data.errorCode);
            })
            .catch((error) => 
            {   if (localStorage.getItem("estacionamiento_codigoerror")=="17"){
                localStorage.setItem("estacionamiento_act_action","crear");
                    hacerRegistro();    
                }
            else 
                if (localStorage.getItem("estacionamiento_codigoerror")=="20"){
                    localStorage.setItem("estacionamiento_act_action","activar")  ;
                    hacerOlvidoClave();
            } else {
                LogServices.log("Login a estacionamientos ",localStorage.getItem("estacionamiento_celular"), error.message, error);

                navigate("/estacionamientoerror");
            }
            });
        }

        const recuperoPrimerCelular = () =>{
            return EstacionamientoService.recuperoPrimerCelular(localStorage.getItem("hashLogin"),
                localStorage.getItem("estacionamiento_documento"))
                .then((resp)=> {
                    localStorage.setItem("estacionamiento_celular",resp.data.description);
                    loginEstacionamientos();
                })
                .catch((error)=>{
                    console.log("Error buscando primer Celular, se usara el de CIudadanos");
                    console.log(error);
                    LogServices.log("Error Busqueda celular parking_phone de usuarios ", localStorage.getItem("estacionamiento_celular"),error.message, error)
                    loginEstacionamientos();
                })
        } 
    
        const convertir = (fechaNacimiento)  =>{
            return fechaNacimiento.substring(8,10)+"/"+fechaNacimiento.substring(5,7)+"/"+fechaNacimiento.substring(0,4);
        }

        const loginCiudadanos = () => {
            CiudadanosService.getDatosCiudadano(localStorage.getItem("hashLogin"))
            .then((resp)=>{
                localStorage.setItem("estacionamiento_celular", resp.data.Celular );
                localStorage.setItem("estacionamiento_pass", resp.data.DNI+"A"+resp.data.FechaNacimiento.substring(0,10));
                localStorage.setItem("estacionamiento_documento", resp.data.DNI);
                localStorage.setItem("estacionamiento_email",resp.data.Email);
                localStorage.setItem("estacionamiento_fecha_nacimiento",convertir(resp.data.FechaNacimiento))
                recuperoPrimerCelular();
            })
            .catch((error)=>{
                console.log(error);
                LogServices.log("Error Estacionamientos Login ",localStorage.getItem("estacionamiento_celular"),error.message,error);
                navigate("/estacionamientoerror");
            })
        }

      useEffect(()=> {
        setLoading(true);
        loginCiudadanos();
       },[])

    return (
        <>
       <div class="container text-center estacionamientoContent" >
       <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/")}}/>
       <EstacionamientoSmallHeader texto="" retorno="/"/>
       {loading ?  <div align="center">
   <Spinner color="primary" align="center"/></div>:<div class="row">
                <div class="col">
                    <div className="buttonContainer">
                        <button className="buttonSemiHighClip buttonGreyClip" > 
                        <img className="buttonCreditImage" src="./estacionamiento-pesos.png"/>
                        Cr&eacute;dito disponible <b>{availableCredit.replace(" ","")}</b></button>
                    </div>
                </div>
            </div>}
       {loading?"":<>
            {localStorage.getItem("estado_estacionamiento") != "1" ?<div class="row">
                <div class="col">
                    <div className="buttonContainer">
                        <button className="buttonEstacionamientoClip" onClick={() => navigate("/estacionamientopatente")}> Iniciar Estacionamiento</button>
                    </div>
                </div>
            </div>:
            <div class="row">
            <div class="col">
                <div className="buttonContainer">
                    <button className="buttonEstacionamientoClip" onClick={() => navigate("/estacionamientoinicio")}>Ver Estacionamiento</button>
                </div>
            </div>
        </div>}</>}

            <div class="row">
                <div class="col">
                    <div className="buttonContainer">
                        <button className="buttonEstacionamientoClip" onClick={() => navigate("/estacionamientomapas")}> Consultar lugares libres</button>
                    </div>
                </div>
            </div>
           
        </div>
        <Botonera/>
        </>
    )
    ;
    }
export default EstacionamientoSites;